import * as firebase from "firebase";
import StellarSdk from "stellar-sdk";

// Create a new keypair.
const issuingKeypair = StellarSdk.Keypair.random();
const server = new StellarSdk.Server("https://horizon-testnet.stellar.org");

async function createIssuerAccount() {
  try {
      console.log(
        "Funding a new account on the test network (takes a few seconds)…"
      );
      console.log(issuingKeypair.publicKey());
      const response = await fetch(
        `https://friendbot.stellar.org?addr=${issuingKeypair.publicKey()}`
      );
      const data = await response.json();
      console.log(data);
      console.log(`Public Key: ${issuingKeypair.publicKey()}`);
      console.log(`Secret Key: ${issuingKeypair.secret()}`);
      return "Success! You have a funded Testnet account :)";
    } catch (e) {
      console.error("Oh no! Something went wrong:", e);
    }
}

    // New Asset
    const usd = new StellarSdk.Asset(
      "USD",
      issuingKeypair.publicKey(),
    );

    const sgd = new StellarSdk.Asset(
      "SGD",
      issuingKeypair.publicKey(),
    );

    const availableCurrency = "100000";

    async function issueAsset(distributionKeypair, amount, currency) {
      console.log("Issue Asset for Public Key: " + distributionKeypair.publicKey());
      const asset = currency === 'SGD' ? sgd : usd;
      try {
        await fetch(
          `https://friendbot.stellar.org?addr=${distributionKeypair.publicKey()}`,
        );
        console.log("-------------------------------------")
        // Fetch the base fee and the account that will create our transaction
        const [
          {
            max_fee: { mode: fee },
          },
          distributionAccount,
        ] = await Promise.all([
          server.feeStats(),
          server.loadAccount(distributionKeypair.publicKey()),
        ]);

        console.log("HERE");
    
        const changeTrustTx = new StellarSdk.TransactionBuilder(
          distributionAccount,
          {
            fee,
            networkPassphrase: StellarSdk.Networks.TESTNET,
          },
        )
          .addOperation(
            // The `changeTrust` operation creates (or alters) a trustline.
            StellarSdk.Operation.changeTrust({
              asset: asset,
              limit: "100000",
            }),
          )
          .addOperation(
            // One transaction can have operations from different accounts,
            // they just need to be signed by each account.
            StellarSdk.Operation.payment({
              destination: distributionKeypair.publicKey(),
              asset: asset,
              amount: amount,
              source: issuingKeypair.publicKey(),
            }),
          )
          .setTimeout(100)
          .build();
        changeTrustTx.sign(distributionKeypair);
        changeTrustTx.sign(issuingKeypair);
    
        console.log(
          `Making trustline and issuing ${amount} AstroDollars…`,
        );
        const txResult = await server.submitTransaction(changeTrustTx);
    
        // recoupLumens(issuingKeypair.secret());
        console.log(
          `Success! ${
            issuingKeypair.publicKey()
          } issued ${amount} AstroDollars to ${
            distributionKeypair.publicKey()
          }`,
        );
        console.log(txResult);
        return txResult;
      } catch (e) {
        console.log(e);
        console.error("Oh no! Something went wrong.");
        console.error(e.response.data.detail);
        console.error(e.response.data.extras.result_codes);
        console.error(e.response.data.type);
        // recoupLumens(issuingKeypair.secret());
        return e.response.data;
      }
    }
    
    
   export const createAccount = (uid) => {
      const newPair = StellarSdk.Keypair.random();
      firebase.database().ref("/users/"+uid).update({
        publicKey: newPair.publicKey(),
        privateKey: newPair.secret()
      },
      function(error) {
        if (error) {
          // The write failed...
          console.log("Update account failed!")
        } else {
          // Data saved successfully!
          console.log("success");
        }
      })
      var resp = firebase.database().ref('users/'+ uid);
      // console.log()
      resp.on('value', function(snapshot) {
        var val = snapshot.val()
        issueAsset(newPair, '10000', val.currency);
      });
    }

   export const makePayment =async (distributionKeypair, destKeypair, sendAsset, destAsset, amount) => {
    const toSend = sendAsset === 'sgd' ? sgd : usd;
    const toDest = destAsset === 'sgd' ? sgd : usd;
    try {
        const [
          {
            max_fee: { mode: fee },
          },
          distributionAccount,
          destAccount
        ] = await Promise.all([
          server.feeStats(),
          server.loadAccount(distributionKeypair.publicKey()),
          server.loadAccount(destKeypair.publicKey()),
        ]);

        const changeTrustTx = new StellarSdk.TransactionBuilder(
          distributionAccount,
          {
            fee,
            networkPassphrase: StellarSdk.Networks.TESTNET,
          },
        )
          .addOperation(
            // One transaction can have operations from different accounts,
            // they just need to be signed by each account.
            StellarSdk.Operation.pathPayment({
              sendAsset: toSend,
              sendMax:(amount*2).toFixed(4),
              destination: destAccount,
              destAmount: amount,
              destAsset: toDest,
              path: [StellarSdk.Asset.native(), ]
            }),
          )
          .setTimeout(100)
          .build();
        changeTrustTx.sign(distributionKeypair);
        changeTrustTx.sign(destKeypair);
      } catch (e) {
        console.error(e);
        console.error("Oh no! Something went wrong.");
        console.error(e.response.data.detail);
        console.error(e.response.data.extras.result_codes);
        console.error(e.response.data.type);
        return e.response.data;
      }
    }

    async function makeBuyOffer(accountKeypair, buying, selling, price) {
      try {
        await fetch(
          `https://friendbot.stellar.org?addr=${accountKeypair.publicKey()}`,
        );
    
        // Fetch the base fee and the account that will create our transaction
        const [
          {
            max_fee: { mode: fee },
          },
          account,
        ] = await Promise.all([
          server.feeStats(),
          server.loadAccount(accountKeypair.publicKey()),
        ]);
    
        if(StellarSdk.Asset.native() === buying){

        const transaction = new StellarSdk.TransactionBuilder(account, {
          fee,
          networkPassphrase: StellarSdk.Networks.TESTNET,
        })
          .addOperation(
            // Our account needs to explicitly trust the asset before we can
            // make an offer
            StellarSdk.Operation.changeTrust({
              asset: buying,
              limit: "100000",
            }),
          )
          .setTimeout(100)
          .build();
        transaction.sign(accountKeypair);
    
        const txResult = await server.submitTransaction(transaction);
        }
        const [
          {
            max_fee: { mode: fee2 },
          },
          account1,
        ] = await Promise.all([
          server.feeStats(),
          server.loadAccount(accountKeypair.publicKey()),
        ]);

        const transaction2 = new StellarSdk.TransactionBuilder(account1, {
          fee,
          networkPassphrase: StellarSdk.Networks.TESTNET,
        })
          // The `manageBuyOffer` operation creates (or alters) a buy offer.
          .addOperation(
            StellarSdk.Operation.manageBuyOffer({
              selling: selling,
              buying: buying,
              buyAmount: "1000.0",
              price: price,
              source: issuingKeypair.publicKey()
            }),
          )
          .setTimeout(100)
          .build();
        transaction2.sign(accountKeypair);
        transaction2.sign(issuingKeypair);
    
        const txResult2 = await server.submitTransaction(transaction2);
    
        // recoupLumens(accountKeypair.secret());
        // console.log(txResult);
        return `Success! ${
          accountKeypair.publicKey()
        } offered to buy 1000 ${selling} for ${price} ${buying} each`;
      } catch (e) {
        console.error(e);
        console.error("Oh no! Something went wrong.");
        console.error(e.response.data.detail);
        console.error(e.response.data.extras.result_codes);
        console.error(e.response.data.type);
        return e.response.data;
      }
    }
    
export const init = async () => {
  // get the root account
  createIssuerAccount();
  firebase.database().ref("/rootAcc").set({
      publicKey: (issuingKeypair.publicKey()),
      privateKey: (issuingKeypair.secret())
  });
  for(var i = 0; i < 15; i++){
      await makeBuyOffer(StellarSdk.Keypair.random(), sgd, StellarSdk.Asset.native(), Math.random().toFixed(4));
      await makeBuyOffer(StellarSdk.Keypair.random(), usd, StellarSdk.Asset.native(), Math.random().toFixed(4));
      let pair = StellarSdk.Keypair.random();
      await issueAsset(pair, "10000", 'usd');
      await makeBuyOffer(pair, StellarSdk.Asset.native(), usd, Math.random().toFixed(4));
      await issueAsset(pair, "10000", 'sgd');
      await makeBuyOffer(pair, StellarSdk.Asset.native(), sgd, Math.random().toFixed(4));
    }
}

    init();

    
    
    


// WEBPACK FOOTER //
// ./src/utils/stellar.js